<template>
  <div
    class="btn"
    @click="click()">
    <div class="label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  props: {
    to: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  methods: {
    click() {
      this.$router.push(this.to);
    },
  },
};
</script>
